import { gql } from '@apollo/client';

export const GET_ALL_CHAT_MESSAGES = gql`
  query GetAllChatMessages($limit: Float!) {
    getAllChatMessages(limit: $limit) {
      id
      content
      role
      displayData
      toolCalls
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
    }
  }
`;
